export const leadership = [
  {
    name: "Ameena Kidwai",
    description: (
      <>
        <p>
          Ameena leads research projects under the safe migration vertical at
          People&apos;s Courage International. Her current focus is on building
          knowledge and evidence products for exploring new avenues for
          intervention and strengthening program design. Prior to this, she
          worked on an independent project with Stanford University. She holds a
          Masters in Development Studies from Ambedkar University, Delhi. Her
          research interests focus on the intersections of migration, informal
          worker and social protection.
        </p>
      </>
    ),
    image: "/images/team/ameesna.webp",
    designation: "Senior Lead, Research",
  },
  {
    name: "Ashif Shaikh",
    description: (
      <>
        <p>
          Born in India to an excluded community, Ashif cofounded Jan Sahas
          (“People&apos;s Courage”) with the dream of empowering socially
          excluded communities drawing from his own lived experience. He’s since
          grown the organization from five volunteers to a network of thousands,
          and they have helped millions of migrant workers and their families
          access safety nets, supported and rehabilitated survivors of sexual
          abuse, trafficking, and manual scavengers. In 2020, Shaikh launched
          the Migrants Resilience Collaborative, a grassroots-led effort to
          closely partner with governments, private sector, and nonprofits to
          support vulnerable migrant families become socio-economically
          resilient. He was awarded the Harvard Kennedy School&apos;s Gleitsman
          International Award in 2022, and named Schwab Foundation Social
          Innovator of the Year in 2020 and an Ashoka Fellow in 2016. Ashif
          serves as a member of various committees of the Government of India.
        </p>
      </>
    ),
    image: "/images/team/aashif.webp",
    designation: "Founder and Chief Executive Officer ",
  },
  {
    name: "Binu Arickal",
    description: (
      <>
        <p>
          Binu leads Regional Operations for South and South East Asia. In this
          role, he plays a crucial part in steering the establishment of a
          comprehensive, long-term program dedicated to migrants across five
          countries in the region. A management graduate, Binu&apos;s transition
          into the development sector was fuelled by the profound satisfaction
          derived from transforming lives. He comes with diverse experience,
          having worked with various organizations at grassroots, national and
          international levels. Prior to this, he led strategic initiatives in
          WaterAid India. He has worked with with Dan Church Aid and Samarthan -
          Centre for Development Support which involved coordination with
          various stakeholders, advocate for safe migration and understand the
          nuances of decentralized governance.
        </p>
      </>
    ),
    image: "/images/team/Binu.webp",
    designation: "Director, Regional Operations",
  },
  {
    name: "Madhumitha Hebbar",
    description: (
      <>
        <p>
          Madhumitha Hebbar leads MRC’s work around creating systems change as
          well as impact measurement. She is responsible for building and
          rigorously testing a portfolio of big bets to help millions of
          internal migrant workers in India access social security benefits
          cheaper, faster, and better. Prior to this, Madhumitha worked as a
          social protection specialist for eight years independently as well as
          with Oxford Policy Management. She supported governments and
          multilateral agencies in delivering the universal social protection
          agenda across South Asia, South-East Asia and Southern Africa. She has
          a Master&apos;s degree in Development Studies from Erasmus University
          Rotterdam.
        </p>
      </>
    ),
    image: "/images/team/madhumitha.jpg",
    designation: "Director, Strategic Initiatives",
  },
  {
    name: "Nitish Narain",
    description: (
      <>
        <p>
          Nitish Narain is the Managing Director for Migrants Resilience
          Collaborative. He provides strategic and operational leadership for
          scaling MRC&apos;s impact across millions of vulnerable and
          marginalized workers. Nitish has over 15 years of experience in
          programmatic leadership, building teams and coalitions, resource
          mobilization, and organizational development. He also brings global
          expertise in designing and scaling viable last mile service delivery
          models and products for the next billion users, largely from
          low-income communities. Previously, Nitish led the Financial Inclusion
          and Policy practice at MicroSave Consulting, where he oversaw project
          delivery across Asia and Africa while managing relations with
          ministries, regulators, multi-laterals, and financial service
          providers. Prior to this, he was with Bharat Financial Inclusion Ltd.,
          leading a team of 100+ people implementing complex microfinance
          operations in India.
        </p>
      </>
    ),
    image: "/images/team/ntisih.webp",
    designation: "Managing Director, Migrants Resilience Collaborative",
  },
  {
    name: "Parul Khandelwal",
    description: (
      <>
        <p>
          Parul Khandelwal is the Global Director of Human Resources at PCI.
          With 18+ years of HR experience, a Master&apos;s in HRM, a PGDBM in
          Business Management, and expertise in talent management, HR systems,
          and technology, Parul has led initiatives to create inclusive
          workplace cultures aligned with social impact goals. Her experience in
          employee engagement, wellbeing, policies, HR laws, change management,
          and OD has supported non-profits in driving sustainable change.
        </p>
        <p className="my-4">
          Before joining PCI, Parul led HR for a 2000+ workforce at the American
          India Foundation and J-PAL South Asia. She also managed HRBP and
          strategic HR roles across India, Southeast Asia, the US, and UAE in
          the IT and video game sectors.
        </p>
        <p>
          Passionate about people-centred strategies in the non-profit sector,
          Parul is dedicated to strengthening organizations and ensuring people
          are at the heart of transformational change.
        </p>
      </>
    ),
    image: "/images/team/parul.webp",
    designation: "Global Director, Human Resources",
  },
  {
    name: "Puja Issar",
    description: (
      <>
        <p>
          Puja leads the fundraising and communications vertical across
          PCI&apos;s thematic areas. She is an accomplished result driven senior
          executive with proven ability to evaluate, identify and execute
          meaningful business in Wealth Management, Financial Services,
          Investment Banking and Development sector across UK, South Africa,
          Middle East and India. Her extensive experience and ability to
          leverage cross sectoral partnerships has resulted in increased
          organizational presence and wallet share. Skilled, imaginative and
          analytical, she has an excellent track record in strategic initiatives
          and developing and implementing value creating business plans. Her
          vast experience across continents makes her attuned to cultural
          diversity, making her management approaches, across national and
          international businesses more meaningful. She has established
          credibility at senior levels of government and corporate bodies and is
          a transformative leader.
        </p>
      </>
    ),
    image: "/images/team/puja.webp",
    designation: "Director, Fundraising & Communications",
  },
  {
    name: "Rajesh Balani",
    description: (
      <>
        <p>
          Rajesh is a Chartered Accountant by qualification and a Graduate in
          Commerce from Delhi University. Having an experience of more than 12
          years in the development Sector, he has involved with more than 200
          National and International NGOs in supporting them by Setting up of
          entities, providing Legal Opinion and conducting Financial Reviews,
          Grant Management, Financial System development, Workshop and Trainings
          helping the development sector in setting up financial systems and
          Internal controls commensurate to the size and nature of the
          respective organizations. Currently, Rajesh is working as the
          Director- Finance wherein he oversees the financial management and
          Compliance of the Charities at USA (501(c)(3)) and UK (Charity
          Commission). Apart from this, he also leads the Finance and Compliance
          vertical at a Project called Grassroots Resilience Institute, which is
          a Capacity Building Program for 30 NGOs across different states of
          India. Previously, he has worked with Financial Management Service
          Foundation (FMSF) serving Not-for-profits across the Globe. He
          specializes in the areas of FCRA, Income Tax, Setting up of an entity
          and other legal Compliances in USA and UK. He has also co-authored
          many training modules and resource materials for various partner NGOs
          in the areas of Income Tax, GST and FCRA. He has also been involved as
          an expert faculty for various online courses such as Certificate in
          Financial Management and Accountability (CFMA) and 21-day Crash course
          in FCRA.
        </p>
      </>
    ),
    image: "/images/team/Rajesh Balani.webp",
    designation: "Associate Director, Finance",
  },
  {
    name: "Dr. Swati Jha",
    description: (
      <>
        <p>
          Dr. Swati Jha is the Director, Grassroots Resilience Institute with
          Jan Sahas. Previously, she oversaw the implementation of the Migrants
          Resilience Collaborative program across India. She holds a PhD in
          Economics and an executive diploma in advanced management. She has
          more than 2 decades of progressive experience in the social sector and
          has held leadership positions at American Indian Foundation, United
          Way, Delhi, Hole-in-the-Wall Educations (NIIT Ltd.) She also
          co-founded ASPIRE, a non-profit focused on education and community
          development.
        </p>
      </>
    ),
    image: "/images/team/swati.webp",
    designation: "Director, Grassroots Resilience Institute",
  },
  {
    name: "Varun Behani",
    description: (
      <>
        <p>
          Varun leads the overall strategy development which includes strategy
          and research verticals. As a founding team member of MRC, he helped
          set up the collaborative, playing a key role across strategy
          development, fundraising, and team development. His current focus is
          on scaling MRC&apos;s work across South and Southeast Asia, and
          advancing MRC&apos;s mission on the global stage. Prior to this, Varun
          worked as a strategy consultant with The Bridgespan Group, supporting
          nonprofits and philanthropies in developing their missions.
        </p>
      </>
    ),
    image: "/images/team/varun.webp",
    designation: "Director, Strategy ",
  },
];
